import React from 'react';

export const RevenueCard = ({ Svg, title, description }) => {
    return (
        <div className="revenue-card-wrapper">
            <div className="revenue-card-icon-block">
                <Svg />
            </div>

            <div className="revenue-card-title-description">
                <p className="revenue-card-title">{title}</p>
                <p className="revenue-card-description">{description}</p>
            </div>
        </div>
    );
};
